import { gql } from "lib/apolloClient";
import {
  toolResponseFragment,
  pypElementRatingFragment,
  remarkFragment,
} from "modules/CommonFragments";
import { assessmentToolFragment } from "modules/AssessmentTool/AssessmentToolFragment";
import {
  organizationElementRatingsFragments,
  plannerElementNodeFragments,
} from "./Fragments";

export const getAssessmentToolForProjectGroupQuery = gql`
  query getAssessmentToolForProjectGroup(
    $id: ID!
    $assessmentToolFilters: AssessmentToolFilters
  ) {
    node(id: $id, type: PROJECT_GROUP) {
      id
      ... on ProjectGroup {
        id
        assessmentTool(filters: $assessmentToolFilters) {
          id
          ... on MypObjectiveRubric {
            ...mypObjectiveRubricItem
          }
        }
      }
    }
  }
  ${assessmentToolFragment.mypObjectiveRubric}
`;

export const getAssessedDataForProjectQuery = gql`
  query getAssessedDataForProject($id: ID!) {
    node(id: $id, type: PROJECT) {
      id
      ... on Project {
        id
        students {
          id
        }
        ibPYPElementRatings {
          ...ratingItem
        }
        toolResponses(userFilter: ALL) {
          ...toolResponseItem
        }
        ibPYPElementRemarks {
          id
          message
          ibPYPElementId
          ibPYPElementType
        }
      }
    }
  }
  ${toolResponseFragment.toolResponse}
  ${pypElementRatingFragment.studentElementRating}
`;

export const getProjectAssessmentRemarkQuery = gql`
  query getProjectAssessmentRemark($id: ID!) {
    node(id: $id, type: PROJECT) {
      id
      ... on Project {
        id
        assessmentRemarks {
          ...remarkMessage
        }
      }
    }
  }
  ${remarkFragment.remarkMessageFragment}
`;

export const getPlannerElementSetNodeQuery = gql`
  query getPlannerElementSetNode($id: ID!, $filters: PlannerElementFilters) {
    node(id: $id, type: PLANNER_ELEMENT_SET) {
      id
      ... on PlannerElementSet {
        id
        type
        nodes(filters: $filters) {
          ...basicPlannerElementNodeItem
        }
      }
    }
  }
  ${plannerElementNodeFragments.basicPlannerElementNode}
`;

export const getOrganizationAcademicCriteriaValuesQuery = gql`
  query getOrganizationAcademicCriteriaValues(
    $id: ID!
    $filters: RatingLevelsFilter
    $finalGradeFilters: RatingLevelsFilter
    $fetchFinalGrade: Boolean!
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        constants {
          ratingLevels(filters: $filters) {
            ...basicOrganizationElementRatingsItem
          }
          finalGradeRatingLevels: ratingLevels(filters: $finalGradeFilters)
            @include(if: $fetchFinalGrade) {
            ...basicOrganizationElementRatingsItem
          }
        }
      }
    }
  }
  ${organizationElementRatingsFragments.basicOrganizationElementRatings}
`;

export const getProjectAcademicCriteriaValueQuery = gql`
  query getProjectAcademicCriteriaValue($id: ID!) {
    node(id: $id, type: PROJECT) {
      id
      ... on Project {
        id
        ibPYPElementRatings {
          ...basicIBPYPElementRatingItem
        }
      }
    }
  }
  ${pypElementRatingFragment.basicIBPYPElementRating}
`;

// INDIVIDUAL LEVEL

export const getIndividualAssessmentDataForProjectQuery = gql`
  query getIndividualAssessmentDataForProjectQuery(
    $id: ID!
    $filters: ProjectStudentsCollaboratorFilters
  ) {
    node(id: $id, type: PROJECT) {
      id
      ... on Project {
        id
        studentCollaborators(filters: $filters) {
          id
          student {
            id
          }
          ibPYPElementRatings {
            ...ratingItem
          }
          ibPYPElementRemarks {
            id
            message
            ibPYPElementId
            ibPYPElementType
          }
          toolResponses(userFilter: ALL) {
            ...toolResponseItem
          }
          assessmentRemarks {
            ...remarkMessage
          }
        }
      }
    }
  }
  ${remarkFragment.remarkMessageFragment}
  ${toolResponseFragment.toolResponse}
  ${pypElementRatingFragment.studentElementRating}
`;
